import { useState, useRef, useEffect } from "react";
import Button from "../../../../../../../components/Button/Button";
import PlusFilledIcon from "../../../../../../../assets/svg/plus-filled-icon";
import { FIELD_OPTIONS } from "../utils/constants";
import type { AddCustomFieldMenuProps } from "../utils/types";

const AddCustomFieldMenu = ({ onSelect }: AddCustomFieldMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef?.current && !menuRef?.current?.contains(e?.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="relative" ref={menuRef}>
      <Button
        type="button"
        innerText="Add Custom Field"
        Icon={PlusFilledIcon}
        iconLeft
        onClick={() => setIsOpen((prev) => !prev)}
        buttonContainerClass="h-fit w-fit bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk bg-verba-blue dark:bg-verba-blue-dk rounded-[8px] px-3.5 py-2"
        innerTextClass="text-md font-medium text-fixed-white dark:text-fixed-white-dk whitespace-nowrap"
        iconClass="!w-[18px] !h-[18px] text-fixed-white dark:text-fixed-white-dk shrink-0"
      />

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-[200px] backdrop-blur-[20px] bg-popper-bg dark:bg-popper-bg-dk rounded-[8px] border border-border-gray dark:border-border-gray-dk shadow-popper-blur-effect z-50 p-3">
          <div className="flex flex-col">
            {FIELD_OPTIONS?.map((option) => {
              const Icon = option.icon;
              return (
                <button
                  key={option.id}
                  type="button"
                  onClick={() => {
                    onSelect(option.id);
                    setIsOpen(false);
                  }}
                  className="w-full flex items-center gap-1 px-2 py-2 rounded-[8px] hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-colors cursor-pointer"
                >
                  <div className="w-[18px] h-[18px] shrink-0 flex items-center justify-center">
                    <Icon className={option.iconClass} />
                  </div>
                  <span className="text-md font-normal text-heading-text dark:text-heading-text-dk leading-normal whitespace-nowrap">
                    {option.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default AddCustomFieldMenu;
